import { createShortQuiz } from './shortQuiz'
import { createLongQuiz } from './longQuiz'
import { createDefaultQuiz } from './default'
import { createAddressAtEndQuiz } from './addressAtEnd'
import { createHomeInfoQuiz } from './homeInfo'
import type { FormFlow } from '../../../types/form'
import type { FormStepResult } from '../../types'

export type QuestionnaireFactory = (formResults?: FormStepResult) => FormFlow

export const questionnaireMap = {
  default: createDefaultQuiz,
  shortQuiz: createShortQuiz,
  longQuiz: createLongQuiz,
  addressAtEnd: createAddressAtEndQuiz,
  homeInfo: createHomeInfoQuiz,
} as const satisfies Record<string, QuestionnaireFactory>

export type MonarchQuestionnaireName = keyof typeof questionnaireMap
